import React, { useState, useContext } from "react";
import { Box, Typography } from "@mui/material";
import { getColors } from "../../themes/theme";
import { ThemeContext } from "../../context/ThemeContext";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import { EditCitationDialog } from "./EditCitationDialog";
import { useAuthContext } from "../../hooks/contexts/useAuthContext";
import axios from "axios";
import { useSnackbar } from "notistack";

export const CitationItem = ({ id, name, onCitationUpdate }) => {
  const { token } = useAuthContext();
  const { darkMode } = useContext(ThemeContext);
  const [openEditDialog, setOpenEditDialog] = useState(false); // New state for confirmation dialog
  const [citationToEdit, setCitationToEdit] = useState(null); // New state for the user to be deleted
  const { enqueueSnackbar } = useSnackbar();

  const handleClick = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/citation/name/${name}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    setCitationToEdit(response.data);
    setOpenEditDialog(true);
  };

  const handleCancelEdit = () => {
    setOpenEditDialog(false);
  };

  const handleEditCitation = async (data) => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/citation/citations/${data.treatmentName}`,
        { citations: data?.citations }, // Wrap the array in an object
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      onCitationUpdate(response.data); // Update the parent state
      enqueueSnackbar("Successfully Changed!", { variant: "success" });
    } catch (error) {
      enqueueSnackbar("Failed to update treatment!", { variant: "error" });
    }
  };

  return (
    <>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        sx={{
          width: "475px",
          height: "120px",
          padding: 1,
          borderRadius: "5px",
          borderWidth: 1,
          borderStyle: "solid",
          borderColor: darkMode
            ? getColors.thumbnailBorderDark
            : getColors.thumbnailBorderLight,
          background: darkMode
            ? getColors.thumbnnailBgDark
            : getColors.thumbnnailBgLight,
          cursor: "pointer",
          "&:hover": {
            borderColor: darkMode
              ? getColors.thumbnailTextDark
              : getColors.thumbnailTextLight,
          },
        }}
      >
        <Box display={"flex"} alignItems={"center"}>
          <Typography
            sx={{
              fontSize: "22px",
              fontWeight: 500,
              color: darkMode
                ? getColors.drawerTextDark
                : getColors.thumbnailTextLight,
              ml: "20px",
            }}
          >
            {name}
          </Typography>
        </Box>
        <Box display="flex">
          <Box
            display={"flex"}
            justifyContent={"flex-end"}
            width="max-content"
            sx={{
              borderRadius: "50%",
              padding: "20px",
              color: "#007FFF",
              bgcolor: "#E9F3FF",
              alignItems: "center",
              "&:hover": {
                color: "blue",
              },
              mr: 2,
            }}
            onClick={handleClick} // Move the onClick handler here
          >
            <BorderColorOutlinedIcon />
          </Box>
        </Box>
      </Box>
      <EditCitationDialog
        open={openEditDialog}
        onClose={handleCancelEdit}
        citationName={name}
        citationData={citationToEdit}
        onSave={handleEditCitation}
      />
    </>
  );
};
